<div style="padding: 24px">
  <h5 mat-dialog-title class="text-center">Editar imagen</h5>
  <div mat-dialog-content>
    <button (click)="fileoInput.click()" mat-raised-button color="primary" style="height: fit-content">Cargar logo</button>
    <span style="visibility: hidden; position: absolute; overflow: hidden; width: 0px; height: 0px; border: none; margin: 0; padding: 0">
      <input type="file" #fileoInput (change)="fileChangeEvent($event)" />
    </span>
    <div class="row">
      <div class="col-md-6 d-flex justify-content-center align-item-center">
        <image-cropper [imageChangedEvent]="imageChangedEvent" format="png" [maintainAspectRatio]="false" [resizeToHeight]="200" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
      </div>
      <div class="col-md-6 d-flex justify-content-center align-item-center">
        <img [src]="croppedImage" style="max-width: 100%" />
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button (click)="onNoClick(false)">Cerrar</button>
    <button mat-button cdkFocusInitial (click)="uploadFile()">Aplicar</button>
  </div>
</div>
